import { useIntl } from 'react-intl';

import { VisitStatisticTotalsKey } from 'src/features/statistic/types';
import { RECHARTS_COLOR_FILLS, statisticsTypeMapping } from 'src/features/statistic/utils/constants';
import { cn } from 'src/utils/shadcn';

type MapLegendProps<T> = {
    colorMapping?: Record<string, string>;
    dynamicStats?: T[];
    getLabel?: (entry: T) => string;
    className?: string;
};

function MapLegend<T>({ dynamicStats, getLabel, colorMapping, className }: MapLegendProps<T>) {
    const { formatMessage } = useIntl();

    return colorMapping && !dynamicStats ? (
        <div className={cn('flex flex-wrap justify-center gap-4', className)}>
            {Object.entries(colorMapping).map(([key, value]) => {
                return (
                    <div key={key} className="flex flex-wrap items-center gap-1 text-xs sm:text-sm">
                        <div
                            style={{
                                backgroundColor: value,
                                width: 15,
                                height: 15,
                                borderRadius: 50,
                            }}
                        />
                        {formatMessage(
                            statisticsTypeMapping[key as VisitStatisticTotalsKey] ?? {
                                id: 'common.unknown',
                                defaultMessage: key,
                            },
                        )}
                    </div>
                );
            })}
        </div>
    ) : (
        <div className={cn('flex flex-wrap justify-center gap-4', className)}>
            {dynamicStats?.map((entry, i) => {
                return (
                    <div key={i} className="flex flex-wrap items-center gap-1 text-xs sm:text-sm">
                        <div
                            style={{
                                backgroundColor: RECHARTS_COLOR_FILLS[i % RECHARTS_COLOR_FILLS.length],
                                width: 15,
                                height: 15,
                                borderRadius: 50,
                            }}
                        />
                        {getLabel && <span>{getLabel(entry)}</span>}
                    </div>
                );
            })}
        </div>
    );
}

export default MapLegend;
